var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center justify-content-center"},[_c('img',{attrs:{"src":_vm.thisimagename}}),_c('div',{staticClass:"box w-100 justify-content-center flex-column",staticStyle:{"position":"absolute","top":"100px","left":"0px","z-index":"20"}},[_c('h3',[_vm._v(_vm._s(_vm.progress)+"%")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }